'use strict';

var curry2 = require('../_internal/_curry2');

module.exports = curry2(function prop(p, obj) {
  return obj[p];
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/prop/index.js
// module id = 195
// module chunks = 0